module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "hello"
  }, [_h('hr', {
    attrs: {
      "width": "60%"
    }
  }), " ", _h('hr', {
    attrs: {
      "width": "40%"
    }
  }), " ", _h('hr', {
    attrs: {
      "width": "20%"
    }
  }), " ", _h('h1', [_vm._s(_vm.msg)]), " ", _h('hr', {
    attrs: {
      "width": "20%"
    }
  }), " ", _h('hr', {
    attrs: {
      "width": "40%"
    }
  }), " ", _h('hr', {
    attrs: {
      "width": "60%"
    }
  }), " ", _h('h3', [_vm._s(_vm.task)]), " ", _h('h3', [_vm._s(_vm.topictext) + " " + _vm._s(_vm.topic)]), " ", _h('p', [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.topic),
      expression: "topic"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.showInput),
      expression: "showInput"
    }],
    attrs: {
      "type": "text",
      "id": "theme",
      "placeholder": "Dein Thema?"
    },
    domProps: {
      "value": _vm._s(_vm.topic)
    },
    on: {
      "blur": function($event) {
        _vm.finishInput()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.topic = $event.target.value
      }
    }
  })]), " ", _vm._l(('A B C D E F G H I J K L M N O P Q R S T U V W X Y Z'.split(' ')), function(i) {
    return _h('div', ["\n        " + _vm._s(i) + " ", _h('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.answers[i]),
        expression: "answers[i]"
      }],
      staticClass: "buchstabe",
      attrs: {
        "type": "text",
        "name": "buchstabe",
        "placeholder": "???"
      },
      domProps: {
        "value": _vm._s(_vm.answers[i])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.answers,
            $$idx = i;
          if (!Array.isArray($$exp)) {
            _vm.answers[i] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    })])
  }), " ", _h('button', {
    on: {
      "click": function($event) {
        _vm.printlocal()
      }
    }
  }, ["Sende an lokalen Drucker und wähle dann als Druckausgabe ", _h('b', ["PDF"])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-379cc8dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ABCList.vue
// module id = 9
// module chunks = 1